import React from "react"
import Slider from "react-slick"

const MobileUsp = (props) => {
  const uspLinks = props.usp.links
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 760,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 1,
    slidesToScroll: -1,
    vertical: true,
    pauseOnHover: true,
  }

  if (uspLinks) {
    return (
      <div
        className={"mobile-usp-list"}
        style={{
          backgroundColor: props.usp.bgColor ?? "black",
          color: props.usp.textColor ?? "white",
        }}
      >
        <Slider {...settings}>
          {uspLinks.map((l) => {
            return (
              <a key={l.text} href={l.href}>
                <div className={"usp-link-text"}>{l.text}</div>
              </a>
            )
          })}
        </Slider>
      </div>
    )
  } else {
    return ""
  }
}

export default MobileUsp
